import React__default from 'react';

const VERSION = "13310788";
const ZINNIA_STYLESHEET_URL = `https://design-system-css.zapier.com/design-system/${VERSION}.css`;
const ZinniaStylesheet = (props) => {
  return React__default.createElement("link", Object.assign({ href: ZINNIA_STYLESHEET_URL, rel: "stylesheet" }, props));
};

export { ZINNIA_STYLESHEET_URL, ZinniaStylesheet };
//# sourceMappingURL=ZinniaStylesheet.es.js.map
